import { render, staticRenderFns } from "./SLAAgreement.vue?vue&type=template&id=2f270cc4&"
import script from "./SLAAgreement.vue?vue&type=script&lang=js&"
export * from "./SLAAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports